import {
  FunctionComponent,
} from 'react';
import { Route } from 'react-router-dom';

import { AdminRouteName } from '../CONSTANTS';
import DashboardWrap from '../../components/DashboardWrap';
import {
  SubmittedEquifaxReports,
  NotSubmittedEquifaxReports,
  AllEquifaxReports,
} from './_partials';

import './AdminEquifaxReport.scss';

const AdminEquifaxReport: FunctionComponent = () => (
  <DashboardWrap>
    <div className="equifax-report-root-cover">
      <Route
        component={AllEquifaxReports}
        path={AdminRouteName.equifaxReportRoute}
        exact
      />
      <Route
        component={SubmittedEquifaxReports}
        path={AdminRouteName.equifaxSubmittedReportRoute}
        exact
      />
      <Route
        component={NotSubmittedEquifaxReports}
        path={AdminRouteName.notSubmittedEquifaxReportRoute}
      />
    </div>
  </DashboardWrap>
);

export default AdminEquifaxReport;
